import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid } from 'gridjs-react';
import { html } from 'gridjs';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Modal, ModalBody, Button } from '../../../Components/ui';
import { API, BACKEND_HOST } from '../../../api';
import { dialogService } from "@/utils/dialogService";
export default function CouponBookRuleList() {
    const navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [delRecord, setDelRecord] = React.useState<number | null>(null);
    const [modalDelete, setModalDelete] = React.useState(false);
    const handleEdit = useCallback((id: number) => {
        navigate(`/couponbook-form/${id}`);
    }, [navigate]);
    const handleDelete = useCallback((id: number) => {
        setDelRecord(id);
        setModalDelete(true);
    }, []);
    // Event listeners for gridjs button clicks (since html() doesn't support React onClick)
    useEffect(() => {
        const handleEditEvent = (e: CustomEvent) => {
            handleEdit(e.detail);
        };
        const handleDeleteEvent = (e: CustomEvent) => {
            handleDelete(e.detail);
        };
        window.addEventListener('editCouponBook', handleEditEvent as EventListener);
        window.addEventListener('deleteCouponBook', handleDeleteEvent as EventListener);
        return () => {
            window.removeEventListener('editCouponBook', handleEditEvent as EventListener);
            window.removeEventListener('deleteCouponBook', handleDeleteEvent as EventListener);
        };
    }, [handleEdit, handleDelete]);
    const fields = [
        {
            name: "id",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "coupon_name",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "start_date",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "end_date",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "state",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: "type",
            formatter: (cell: any) => html(`<span class="fw-semibold">${cell ?? ''}</span>`),
        },
        {
            name: 'Actions',
            width: '140px',
            formatter: (cell: any) => {
                const safeId = Number(cell);
                if (!Number.isFinite(safeId)) {
                    return html('');
                }
                return html(`<div class="d-flex gap-2">
					<div class="edit">
						<button class="btn btn-sm btn-success edit-item-btn" onclick="window.dispatchEvent(new CustomEvent('editCouponBook', {detail: ${safeId}}))">Edit</button>
					</div>
					<div class="remove">
						<button class="btn btn-sm btn-danger remove-item-btn" onclick="window.dispatchEvent(new CustomEvent('deleteCouponBook', {detail: ${safeId}}))">Delete</button>
					</div>
				</div>`);
            }
        }
    ];
    function fetchData() {
        API.get(`${BACKEND_HOST}/coupon/rules/?include_hidden=true`)
            .then((res) => {
            const data = res.data;
            const fieldList = ["id", "coupon_name", "start_date", "end_date", "state", "type"];
            let dataArr = [];
            data.forEach((item) => {
                console.log(item);
                let itemValues = [];
                fieldList.forEach((field) => {
                    itemValues.push(item[field]);
                });
                itemValues.push(item.id);
                dataArr.push(itemValues);
            });
            setData(dataArr);
        })
            .catch(e => console.log(e));
    }
    React.useEffect(() => {
        fetchData();
    }, []);
    const deleteRecord = () => {
        API.delete(`${BACKEND_HOST}/coupon/rules/${delRecord}/`)
            .then(async (res) => {
            await dialogService.handleAlert("Delete ok!");
            setModalDelete(false);
            fetchData();
        })
            .catch(async (e) => await dialogService.handleAlert(e, { force: "error" }));
    };
    return (<React.Fragment>
			<div className="page-content">
				<div className="container-fluid">
					<BreadCrumb title="쿠폰목록" pageTitle="쿠폰"/>
					<div className="flex flex-wrap -mx-3">
						<div className="w-full px-3">
							<div className="card">
								<div className="card-header" style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
									<h4 className="card-title mb-0 flex-grow-1">쿠폰북 다운로드 조건 목록</h4>
									<div>
										<Button onClick={() => { navigate(`/couponbook-form/${0}`); }} id="create-btn" color="success" className="add-btn me-1"><i className="ri-add-line align-bottom me-1"></i> Add</Button>

									</div>
								</div>

								<div className="card-body">
									<div id="coupon-table-gridjs">
										<Grid data={data} columns={fields} search={false} sort={true} pagination={{ limit: 10, }}/>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Remove Modal */}
			<Modal isOpen={modalDelete} onClose={() => setModalDelete(false)}>
				<ModalBody className="text-center p-5">
					<div className="mt-4">
						<h4 className="mb-3">Are you Sure ?</h4>
						<p className="text-muted mb-4">{`Are you Sure You want to Remove this Record(id:${delRecord}) ?`}</p>
						<div className="hstack gap-2 justify-content-center">
							<Button onClick={() => { setDelRecord(null); setModalDelete(false); }} color="light">Cancel</Button>
							<Button onClick={deleteRecord} color="danger">Delete</Button>
						</div>
					</div>
				</ModalBody>
			</Modal>
		</React.Fragment>);
}
